import { Alert } from '@mui/material';
import { lang } from 'src/utils';
import { GcfMockData } from 'src/utils/gcf-helper';

interface IProps {
  customerState: Partial<GcfMockData>;
}

const AlertMessages = {
  [GcfMockData.COD_CUSTOMER_UNKNOWN]: lang.customerUnknown,
  [GcfMockData.COD_CUSTOMER_KNOWN]: lang.customerKnown,
  [GcfMockData.COD_CUSTOMER_KNOWN_MOP]: lang.customerKnownMop,
  [GcfMockData.COD_PAGINATED]: '',
  [GcfMockData.COD_EXPANDED]: '',
  [GcfMockData.COD_EXPANDED_WITH_SMALL_BANNER]: '',
  [GcfMockData.COD_CUSTOMER_KNOWN_UNLINKED_PAYMENT]: '',
  [GcfMockData.DY_RECOMMENDATIONS_UPDATE]: '',
  [GcfMockData.DY_SUGGESTIONS_OPEN]: '',
  [GcfMockData.DY_SUGGESTIONS_CLOSE]: '',
};

export const CustomerStateAlert = ({ customerState }: IProps) => {
  return (
    <Alert
      severity="info"
      sx={{
        marginTop: '4px',
        marginBottom: '8px',
        width: 'fit-content',
        marginX: 'auto',
      }}>
      {AlertMessages[customerState]}
    </Alert>
  );
};
